import { render, staticRenderFns } from "./ManageRespondents.vue?vue&type=template&id=58f5f720&scoped=true&"
import script from "./ManageRespondents.vue?vue&type=script&lang=ts&"
export * from "./ManageRespondents.vue?vue&type=script&lang=ts&"
import style0 from "./ManageRespondents.vue?vue&type=style&index=0&id=58f5f720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5f720",
  null
  
)

export default component.exports